import React from 'react';
import { Modal } from 'antd';
import { FormattedMessage } from 'react-intl';

import { IImage } from '@share/common-types';

import './style.scss';

interface IProps {
  images: IImage[];
  visible: boolean;
  hotelName: string;
  onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  onSelect: (index: number) => void;
}

export const QuintessPhotoGrid: React.FunctionComponent<IProps> = ({
  images,
  visible,
  hotelName,
  onCancel,
  onSelect,
}: IProps) => (
  <Modal
    className="quintess-photo-grid"
    wrapClassName="quintess-photo-grid-wrapper"
    visible={visible}
    footer={null}
    onCancel={onCancel}
  >
    <div className="quintess-photo-grid__header">
      <h4 className="quintess-photo-grid__title">{hotelName}</h4>
      <p className="quintess-photo-grid__count">
        <FormattedMessage id="photos.count" values={{ count: images.length }} />
      </p>
    </div>

    <div className="quintess-photo-grid__grid">
      {images.map((image, index) => (
        <button
          type="button"
          key={`${image.url}-${index}`}
          className="quintess-photo-grid__item"
          onClick={() => onSelect(index)}
        >
          <img
            className="quintess-photo-grid__image"
            src={image.url}
            alt={image.description || hotelName}
            loading="lazy"
          />
        </button>
      ))}
    </div>
  </Modal>
);
